<template>
  <div class="coupon">
    <div class="text">反馈有奖励 买菜更便宜</div>
    <div class="rule" @click="goRule">活动规则</div>
    <div v-if="couponInfo.amountDeduction" class="content">
      <div class="info">满{{ couponInfo.amountFull }}可用</div>
      <!-- <div class="unit">¥</div> -->
      <div class="number">{{ couponInfo.amountDeduction }}</div>
      <!-- <div class="type">{{ couponInfo.category }}商品券</div> -->
      <div class="type">元优惠券</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    couponInfo: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    goRule() {
      location.href = this.couponInfo.ruleUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon {
  width: 100%;
  height: 3.62rem;
  background-image: url(('~@/images/market_research/cover_bg.png'));
  background-size: 100% 100%;
  background-origin: border-box;
  padding-top: 0.2rem;
  .text {
    height: 0.36rem;
    line-height: 0.46rem;
    font-size: 0.38rem;
    color: rgb(255, 220, 185);
    text-align: center;
    font-weight: 600;
  }
  .rule {
    position: absolute;
    top: 0.24rem;
    right: 0;
    width: 1.44rem;
    height: 0.44rem;
    line-height: 0.44rem;
    text-align: center;
    font-size: 0.24rem;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.24);
    border-radius: 0.22rem 0 0 0.22rem;
  }
  .content {
    display: flex;
    justify-content: center;
    height: 1.1rem;
    margin-top: 0.1rem;
    .info {
      font-size: 0.24rem;
      color: #ffcbcb;
      margin-right: 0.18rem;
      margin-top: 0.86rem;
    }
    .unit {
      font-size: 0.32rem;
      color: #fff;
      margin-right: 0.1rem;
      margin-top: 0.78rem;
      font-weight: 600;
    }
    .number {
      font-size: 0.88rem;
      color: #fff;
      margin-top: 0.22rem;
      margin-bottom: -0.06rem;
      font-weight: 600;
    }
    .type {
      font-size: 0.24rem;
      color: #ffcbcb;
      margin: 0.86rem 0 0.04rem 0.2rem;
    }
  }
}
</style>
